export const removeTokens = () => {
    localStorage.removeItem('persist:root');
};

export const saveItem = (item, val) => {
    localStorage.setItem(item, val);
};

export const removeItem = (item) => {
    localStorage.removeItem(item);
};
